"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocationChangeActionBase = void 0;
var getIsRoutes_1 = require("../routes/getIsRoutes");
var getUrlQuery_1 = require("../routes/getUrlQuery");
var actions_1 = require("../constants/actions");
// You probably want to use createHistoryAction and not this method
var createLocationChangeActionBase = function (_a) {
    var search = _a.search, hash = _a.hash, pathname = _a.pathname, description = _a.description, routes = _a.routes, queryNames = _a.queryNames;
    var isRoutes = (0, getIsRoutes_1.getIsRoutes)({
        pathname: pathname,
        routes: routes,
    });
    var urlQuery = (0, getUrlQuery_1.getUrlQuery)({
        search: search,
        queryNames: queryNames,
    });
    return {
        type: actions_1.LOCATION_CHANGE,
        description: description,
        values: {
            query: urlQuery,
            queryString: search,
            hash: hash,
            pathname: pathname,
            isRoutes: isRoutes,
        },
    };
};
exports.createLocationChangeActionBase = createLocationChangeActionBase;
